export enum ModalType {
  LEAVE_SURVEY = "LEAVE_SURVEY",
}

export const MODAL_SAGA_ACTION = "modal";
